module.exports = __webpack_public_path__ + "img/Two_Women_Macbook_Scorecard_Tiles.2db9a647.jpg";